const text = {
  airtable: {
    title: 'Airtable ID Map',
    infoTitle: 'How to use',
    infoMessage:
      'Every data field in this database for members, teams, orders, and donations can be mapped to Airtable.\n\nTo do so provide the field ID from Airtable in the inputs below.\n\nThen whenever this data point is created/updated in this database it will be put into Airtable as well.',
    infoMessageRight:
      'Available member fields:\n- Name\n- Checked in\n- Raised\n- Classy member ID\n- Goal \n- Email\n- Classy fundraising page ID\n- Street\n- State\n- City\n- Zip\n- Team name\n- Registration type\n\nAvailable team fields:\n- Team name\n- Classy team ID\n- Team raised\n\nAvailable donation fields:\n- Member name\n- Amount\n- Method\n\nAvailable order fields:\n- Member name\n- Picking up\n- Items owed\n',
  },
  emails: {
    title: 'Email Manager',
    preview: 'Preview',
    infoMessage:
      'You have access to these database records: Member and Event\nSurround them with {{ }} in order for the code to be able to parse it properly and do the replacement.\nUse dot notation to access a property in the record\nFor example to access the member\'s name you would type {{Member.name}}\nThe event name would be {{Event.name}}\nIf you wanted the subject to be "Hi John Doe!" you would put a Subject of: Hi {{Member.name}}!\n\nMake sure to press the save button on the bottom right to save your changes when you are done.\nYou will be able to preview how the email will look below.\nOnce you are done make sure to associate this template with an event.',
    infoMessageRight:
      'Available Member properties: \n- name\n- photo\n- raised\n- memberID\n- goal\n- email\n- fundraisingPageID\n- street\n- city\n- state\n- zipcode\n\nAvailable Event properties: \n- campaignID\n- name',
    infoTitle: 'How to use',
  },
  reports: {
    title: 'Report',
  },
  settings: {
    title: 'Settings',
    notifications: {
      title: {
        disabled: 'Desktop notifications are currently disabled',
        enabled: 'Notify me about:',
      },
      subtitle:
        'Notifications are recommended so you can stay in the loop about all the activity that happens on here!',
      submit: {
        enabled: 'Save Preferences',
        disabled: 'Enable Desktop Notifications',
      },
    },
  },
};

export default text;
